module.exports = __webpack_public_path__ + "static/img/3.a576b63.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/sp/3.png
// module id = tQNd
// module chunks = 0